import React, { Component } from "react";

import { Translate } from "react-redux-i18n";

import "../../../../styles/components/utils/components/pageSelector/PageArrowButton.scss";
import { ReactComponent as Arrow } from "../../../../styles/images/arrow.svg";

class PageArrowButton extends Component {
  render() {
    return (
      <button
        id="pageArrowButton"
        type="button"
        className={`link ${this.props.direction}`}
        onClick={this.props.onClick}
        disabled={this.props.disabled}
      >
        <Arrow />
        {(this.props.direction === "first" || this.props.direction === "last") && <Arrow />}
        <Translate value={`pageArrowButton_${this.props.direction}`} />
      </button>
    );
  }
}

export default PageArrowButton;
